
export default function LawSearchResults({searchTerm, searchResults, total = null , limit}) {
  return (
    <>
      <div className={"search-results__wrapper"}>
        {searchResults.length > 0 &&
          <ul className="search-results__list">
            {searchResults.slice(0, limit).map((result, index) =>
              <li className={"search-result search-result--" + result.type.system} key={index}>
                <article className={"search-result__content"}>
                  <h4 className={"search-result__heading"}>
                    <a className={'search-result__link'} href={result.link}>{result.title}</a>
                  </h4>
                  <div className="search-result__meta">
                    <p className={"label label--small"}>
                      {result.book && result.book.label &&
                        <span>{result.book.label}</span>
                      }
                    </p>
                  </div>
                </article>
              </li>
            )}
          </ul>
        }
      </div>
    </>
  );
}
